import { getArrayApiClient } from 'adapter/out/client/apiClient';
import { ReportInstance } from 'domain/entity/reportInstance';
import ReadReportInstancesCriteria from 'use-case/reportsInstances/read/readReportInstancesCriteria';

const appendParam = (params: URLSearchParams, key: string, value?: string | number): void => {
    if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
    }
};

const appendListParam = (params: URLSearchParams, key: string, values?: string[]): void => {
    if (values && values.length > 0) {
        params.append(key, values.join(','));
    }
};

const buildQueryString = (criteria: ReadReportInstancesCriteria): string => {
    const params = new URLSearchParams();
    appendParam(params, 'start', criteria.start);
    appendParam(params, 'size', criteria.size);
    appendParam(params, 'name', criteria.name);
    appendListParam(params, 'templateDashboardId', criteria.templateDashboardIds);
    appendListParam(params, 'languages', criteria.languageCodes);
    appendListParam(params, 'locationId', criteria.locationIds);
    appendParam(params, 'automationId', criteria.automationId);
    appendListParam(params, 'originTypes', criteria.originTypes);
    appendListParam(params, 'ownership', criteria.ownership);
    appendParam(params, 'from', criteria.from);
    appendParam(params, 'to', criteria.to);
    appendParam(params, 'sort', criteria.sort);
    appendParam(params, 'order', criteria.order);
    const queryString = params.toString();
    return queryString ? `?${queryString}` : '';
};

const readReportInstancesApiClient = getArrayApiClient(
    (criteria: ReadReportInstancesCriteria) => `dashboards/reports${buildQueryString(criteria ?? {})}`,
    ReportInstance
);

export default readReportInstancesApiClient;
